module.exports = __webpack_public_path__ + "img/yuanpan.46c69a68.png";